export default "__VITE_ASSET__0nSHClkL__"